import { useEffect } from 'react'
import { motion } from 'motion/react'
import { Col, Container, Row } from 'react-bootstrap'
import { NavLink, useLocation } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight } from '@fortawesome/free-solid-svg-icons'
import animationVariants from '../../lib/animationVariants'

export default function Quote () {
  const location = useLocation()
  const { direction } = location.state || {}

  useEffect(() => {
    if (location.state) {
      location.state.background = '#000'
    } else {
      location.state = {
        background: '#000'
      }
    }
  }, [location])

  return (
    <motion.div className='w-100 h-100' variants={animationVariants[direction]} initial='hidden' animate='visible' exit='exit'>
      <Container fluid className='w-100 h-100'>
        <Row as='section' id='quote' className='h-100'>
          <Col className='quote-col d-flex justify-content-center align-items-center'>
            <div className='text-quote'>
              <div className='big-quote-mark ldquo'>
                &ldquo;
              </div>
              <span className='quote'>Had it not been for the upbringing we had, Ames Construction would not be the company that it is today.</span>
              <span className='citation'>
                <span>&ensp;– Dick Ames</span>
                <div className='big-quote-mark rdquo'>
                  &rdquo;
                </div>
              </span>
            </div>
            <div>
              <NavLink to='/ames-family-history/family' state={{ direction: 'up' }} className='intro-button'>
                Next &nbsp; <FontAwesomeIcon icon={faChevronRight} />
              </NavLink>
            </div>
          </Col>
        </Row>
      </Container>
    </motion.div>
  )
}
